import { Target, Zap, Users, Award, Download, TrendingUp } from "lucide-react";

export default function WaaromFitSmith() {
  const usps = [
    { icon: <Target size={22} />, title: "Duidelijke structuur", desc: "Elk product is overzichtelijk opgezet. Je weet altijd wat je moet doen en wanneer." },
    { icon: <Zap size={22} />, title: "Praktisch toepasbaar", desc: "Geen theorie zonder praktijk. Alles is direct bruikbaar in de sportschool of thuis." },
    { icon: <Users size={22} />, title: "Voor beginners en gevorderden", desc: "Of je net begint of al jaren traint: er is een aanpak die bij jouw niveau past." },
    { icon: <Award size={22} />, title: "Premium uitgewerkt", desc: "Hoogwaardige content, strak ontworpen materialen en aandacht voor elk detail." },
    { icon: <Download size={22} />, title: "Direct te gebruiken", desc: "Geen wachttijd. Je start dezelfde dag nog met je training of cursus." },
    { icon: <TrendingUp size={22} />, title: "Gericht op resultaat", desc: "Alles is ontwikkeld met één doel: jou helpen betere resultaten te behalen." },
  ];
  return (
    <section data-testid="why-fitsmith" className="py-20 lg:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">Onze aanpak</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Waarom FitSmith</h2>
          <p className="text-zinc-400 max-w-xl mx-auto">Geen loze beloftes. Wij leveren wat werkt.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {usps.map(usp => (
            <div key={usp.title} className="usp-card group">
              <div className="usp-icon">{usp.icon}</div>
              <h3 className="text-white font-bold text-lg mb-2">{usp.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{usp.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
